export default __webpack_public_path__ + "static/media/dianoiva_9.c03587f2.jpg";